import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyDM9amxZIkyJGL_iuCEeZPiyZfbYI0FDOI",
    authDomain: "fitnesssappp.firebaseapp.com",
    projectId: "fitnesssappp",
    storageBucket: "fitnesssappp.firebasestorage.app",
    messagingSenderId: "32339162072",
    appId: "1:32339162072:web:427ac0c8b65a7edc9178ad",
    measurementId: "G-RJPQGZELJR"
};


firebase.initializeApp(firebaseConfig);

var db = firebase.firestore();
var auth = firebase.auth();

export { db, auth }